import { GET_SYM_DIA_PROPERTIES } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export const PLACEHOLDER_MAPPING: { [k: string]: string } = {
    'pg-1541659976': 'Since', // Since
    'pg-5243973452': 'Enter details', // Detials
};

export const SINCE_ID = 'pg-1541659976';

export const options: { [k: string]: string } = {
    hours: 'pr-2328162781',
    days: 'pr-2328192567',
    weeks: 'pr-2328252156',
    months: 'pr-2328281948',
    years: 'pr-2328311730',
    hour: 'pr-2328162781',
    day: 'pr-2328192567',
    week: 'pr-2328252156',
    month: 'pr-2328281948',
    year: 'pr-2328311730',
};

export interface SymDiaProperties {
    propertyGroup?: PropertyGroupEntity[] | null;
    icd10_code: string;
    icd10_name: string;
    id: string;
}
export interface PropertyGroupEntity {
    name: string;
    id: string;
    type: 'open-text-box' | 'radio' | 'suggest' | 'prefix-suggest' | 'multi-select-suggest';
    properties?: PropertiesEntity[] | null;
}
export interface PropertiesEntity {
    id: string;
    name: string;
    name_p?: string;
}

export default (symIds: string, diaIds: string): Promise<SymDiaProperties[]> =>
    fetchWithRefresh(GET_SYM_DIA_PROPERTIES(symIds, diaIds)).then((res) => res.json());
